export default __webpack_public_path__ + "static/media/transparent_middle_frame.506ae0bc.svg";